export enum Particle {
  Image,
  Circle,
  Triangle,
  Rectangle
}

export type ParticleType =
  | typeof Rectangle
  | typeof Triangle
  | typeof Circle
  | typeof Image;

import type Image from './Image';
import type Circle from './Circle';
import type Triangle from './Triangle';
import type Rectangle from './Rectangle';

export { default as Point } from './Point';
export { default as Image } from './Image';
export { default as Circle } from './Circle';
export { default as Triangle } from './Triangle';
export { default as Rectangle } from './Rectangle';

export type Shape = Image | Circle | Triangle | Rectangle;
